import { render } from "./search-list.vue?vue&type=template&id=4ddea826"
import script from "./search-list.vue?vue&type=script&lang=js"
export * from "./search-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__